import { isEmpty } from 'lodash-es';

export const getReviewSummaryContent = content => {
  if (isEmpty(content)) return {};

  return content.child('overall-rating').child('totals').getAllMetadata();
};

export const getCustomerReviewSummaryData = content => {
  if (isEmpty(content)) return {};

  const reviewSummaryContent = getReviewSummaryContent(content);

  const customerSummaryContent = content.child('customer-summary').child('summary-1').getAllMetadata().summary;

  const {
    totalReviews,
    overallRating,
    '1starRating': stars1,
    '2starRating': stars2,
    '3starRating': stars3,
    '4starRating': stars4,
    '5starRating': stars5,
  } = reviewSummaryContent;

  return {
    totalReviewsNumber: parseInt(totalReviews, 10),
    averageRating: parseFloat(overallRating),
    reviewNumbersPerRating: [
      { label: '5', numberOfReviews: parseInt(stars5, 10) },
      { label: '4', numberOfReviews: parseInt(stars4, 10) },
      { label: '3', numberOfReviews: parseInt(stars3, 10) },
      { label: '2', numberOfReviews: parseInt(stars2, 10) },
      { label: '1', numberOfReviews: parseInt(stars1, 10) },
    ],
    generatedSummary: customerSummaryContent,
  };
};
